import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import styles from "./ProductsAdd.module.css"; // Certifique-se de criar/renomear este arquivo de estilo

import { Edit } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import FormProducts from "./FormProducts";
import useStore from "./Values";

const ProductsAdd = () => {
  const { uid } = useParams();
  const navigate = useNavigate();
  
  const setCopyProduct = useStore((state) => state.setCopyProduct);

  const [isVisible, setIsVisible] = useState({
    isEdit: !uid,
  });

  const handleVisible = (fieldName: string, e: boolean) => {
    setIsVisible((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
  };

  return (
    <div className={styles.containerProducts}>
      <div className={styles.products}>
        <div className={styles.headerAdd}>
          <div className={styles.header}>
            <h1>Cadastro de Produto</h1>
            <div className={styles.headerButtons}>
              {!!uid && (
                <Button
                  variant="contain"
                  title="Habilitar edição"
                  onClick={() => handleVisible("isEdit", !isVisible.isEdit)}
                >
                  <Edit />
                </Button>
              )}
              <Button
                variant="contain"
                title="Voltar"
                onClick={() => {
                  setCopyProduct(""); // Limpa o estado global ao voltar
                  navigate(-1);
                }}
              >
                <ArrowBackIcon />
              </Button>
            </div>
          </div>
        </div>

        <div className={styles.containerDate}>
          <div className={styles.headerDate}>
            <h2>DADOS DO PRODUTO</h2>
          </div>
          <div className={styles.formDate}>
            <FormProducts
              isEdit={isVisible.isEdit}
              setIsEdit={(value) => handleVisible("isEdit", value)}
              uid={uid}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsAdd;